import React from "react";
import { useSelector } from "react-redux";

import PageTitle from "../../layouts/PageTitle";
import { selectUser } from "../../../store/authSlice";
import EmployeeLedger from "./EmployeeLedger";

const MyImprest = () => {
  const currentUser = useSelector(selectUser);
  const employeeId = currentUser?.localId;

  return (
    <>
      <PageTitle activeMenu="My Imprest" motherMenu="Imprest" />
      {employeeId ? (
        <EmployeeLedger employeeId={employeeId} canManage="own-expenses-only" />
      ) : (
        <div className="rounded-3xl border border-gray-200 bg-white p-6 text-center text-gray-500 shadow-xl shadow-slate-200/70">
          Loading your account...
        </div>
      )}
    </>
  );
};

export default MyImprest;
